import React, { Component } from 'react';
import { connect } from 'react-redux'
import { addImages } from '../../../../actions';
import {orderBy} from 'lodash';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'

const limitCount = 150;

class NewImage extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  onChange = async (e) => {
    const {countImgs} = this.props;
    try {
      let myArray = Array.from(e.target.files).map((item, index) => {
        return {
          item, 
          name_sort: isNaN(parseInt(item.name.replace(/\D+/g,""))) ? index : parseInt(item.name.replace(/\D+/g,"")) 
        }
      });
      myArray = orderBy(myArray, ['name_sort'], ['asc']);

      if(countImgs + myArray.length > limitCount){
        const {formatMessage} = this.context;
        toastr.error(formatMessage('ErrTitleLimitImgs'), formatMessage('ErrTitleLimitImgsMessage'))
        return;
      }

      await this.saveImages(myArray);
      
    } catch (error) {
    }
  }

  saveImages = async (images) => {
    try {
      const {slider, slider_items, loadFileSpiner} = this.props;
      this.props.addImages(images, slider.id, slider_items.length);
    } catch (error) {
    }
  }

  render() {
    const {formatMessage} = this.context;
    const {countImgs} = this.props;
    return (
    <label onClick={() => {
      if(countImgs >= limitCount) {
        toastr.error(formatMessage('ErrTitleLimitImgs'), formatMessage('ErrTitleLimitImgsMessage'))
      }
    }}>{formatMessage('AddImageSlide')}{countImgs < limitCount && <input style={{display: 'none'}} multiple onChange={this.onChange} type="file" />}</label>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  slider: state.slider.item,
  slider_items: state.slider.items,
})

const mapDispatchToProps = {
  addImages
}

export default connect(mapStateToProps, mapDispatchToProps)(NewImage)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/components/Sliders/components/Actions/NewImage.jsx